var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone-input"},[_c('input',{staticClass:"form-control form-control",attrs:{"name":"phone","placeholder":"Podaj numer telefonu","type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.input}})])}
var staticRenderFns = []

export { render, staticRenderFns }